<div class="list-item-wrapper" (click)="itemClick($event)"
  [ngClass]="{'clickable': showActionIcon && !disabled || clickable || selectable, 'margin-two-lines': info2?.length > 0}">
  <!-- The list item -->
  <div class="list-item" [ngClass]="{'disabled-item': disabled, 'margin-two-lines': info2?.length > 0}">
    <div class="list-item-content" [ngClass]="{'margin-two-lines': info2?.length > 0}">
      <div *ngIf="selectable" class="list-item-checkbox">
        <mat-checkbox [checked]="selected">
        </mat-checkbox>
      </div>
      <div *ngIf="showItemStatus" [ngClass]="(itemStatusIcons.length > 1) ? 'icon-begin': 'item-status'">
        <div *ngFor="let itemStatusIcon of itemStatusIcons">
          <mat-icon matBadgePosition="after" matBadgeSize="small" class="mat-badge"
            [matBadge]="itemStatusBadge" [matBadgeHidden]="itemStatusBadge === 0" (click)="itemStatusClick($event)"
            [ngClass]="(itemStatusIcon.class)">{{ itemStatusIcon.icon }}</mat-icon>
        </div>
      </div>
      <div class="text"
        [ngClass]="{'text-normal': showItemStatus && showActionIcon, 'text-no-icon': !showItemStatus && showActionIcon, 'text-no-icon-and-chevron': !showItemStatus && !showActionIcon, 'disabled-color': disabledColorText}">
        <div class="text-title no-select-clickable-items" [ngClass]="{'text-title-center': !info}">{{ title }}</div>
        <div class="info no-select-clickable-items">
          <div class="text-info vcenter">{{ info }}</div>
          <div class="vcenter icons">
            <ng-container *ngFor="let icon of infoIcons">
              <mat-icon *ngIf="!icon.text" class="icon-info vcenter" [ngClass]="icon.class">{{ icon.icon }}</mat-icon>
              <div *ngIf="icon.text" class="text-info vcenter">{{ icon.text }}</div>
            </ng-container>
          </div>

          <div *ngIf="showSignalStrength" class="signal-strength vcenter">
            <div class="signal-strength-indicator" [ngClass]="{'signal-strength-indicator-on': signalStrength < 100}">
            </div>
            <div class="signal-strength-indicator" [ngClass]="{'signal-strength-indicator-on': signalStrength < 90}">
            </div>
            <div class="signal-strength-indicator" [ngClass]="{'signal-strength-indicator-on': signalStrength < 80}">
            </div>
            <div class="signal-strength-indicator" [ngClass]="{'signal-strength-indicator-on': signalStrength < 70}">
            </div>
            <div class="signal-strength-indicator" [ngClass]="{'signal-strength-indicator-on': signalStrength < 60}">
            </div>
            <div class="signal-strength-value" *ngIf="showSignalStrengthNumeric">{{ signalStrength }}</div>
          </div>

        </div>

        <div class="info no-select-clickable-items" *ngIf="info2?.length > 0">
          <div class="text-info vcenter">{{ info2 }}</div>
          <div class="vcenter icons">
            <ng-container *ngFor="let icon of infoIcons2">
              <mat-icon *ngIf="!icon.text" class="icon-info vcenter" [ngClass]="icon.class">{{ icon.icon }}</mat-icon>
              <div *ngIf="icon.text" class="text-info vcenter">{{ icon.text }}</div>
            </ng-container>
          </div>
        </div>

      </div>

      <div *ngIf="showActionIcon" class="item-more">
        <mat-icon (click)="actionClick($event)" [ngClass]="(actionIcon.class)">
          {{ actionIcon.icon }}
        </mat-icon>
      </div>

    </div>
  </div>
</div>
